import PRODUCT_TYPE from "../const/products";
export var AccountType;
(function (AccountType) {
    AccountType["LOAN"] = "loan";
    AccountType["CARD"] = "card";
    AccountType["PAY_IN_4"] = "payIn4";
    AccountType["SECURED_INSTALLMENT_LOAN"] = "securedInstallmentLoan";
})(AccountType || (AccountType = {}));
/**
 * Based on the API product type, return the broader account-details type
 * @param type Optional ProductType
 * @returns AccountType | undefined if corresponding account type is matched with the product type
 */
var getAccountType = function (type) {
    switch (type) {
        // Loan
        case PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR:
            return AccountType.PAY_IN_4;
        case PRODUCT_TYPE.INSTALLMENT_LOAN:
        case PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY:
            return AccountType.LOAN;
        case PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED:
            return AccountType.SECURED_INSTALLMENT_LOAN;
        // Revolving Credit
        case PRODUCT_TYPE.DUAL_CARD:
        case PRODUCT_TYPE.LIMITED_USE_DUAL_CARD:
        case PRODUCT_TYPE.BUSINESS_RETAIL_CARD:
        case PRODUCT_TYPE.PRIVATE_LABEL:
            return AccountType.CARD;
        default:
            return undefined;
    }
};
export default getAccountType;
//# sourceMappingURL=getAccountType.js.map